import React from "react";

function ModalInfo() {
  return (
    <div
      className="modal fade"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              توضیحات کوتاه در رابطه با دستورالعمل ها
            </h5>
          </div>
          <div className="modal-body">
            جدول خصوصیات و نمودار راداری مقایسه کارایی این صفحه حاوی خصوصیات
            فیزیکی و معمول روانکارها ( مانند VI-V@40-V@100-PP-FP-... ) که در
            تمامی کاتالوگها و دیتا شیتهای روانکارهای مختلف قید شده است نمیباشد و
            صرفا بر راندمان یا خصوصیات شیمیائی این روغنها تمرکز دارد. در این
            جدول و نمودار سعی شده است که اطلاعات نایاب و همگن شده ای که در سایر
            سایتهای مرتبط نمیتوان یافت را جهت مقایسه و آشنایی بیشتر در اختیار
            شما قرار دهیم. برای استفاده ابتدا باید استاندارد یا اپرووال مد نظر
            خود را از منوی سمت چپ، انتخاب صفحه کنید.{" "}
          </div>
          <div className="modal-body">
            توجه 1: اطلاعات مندرج در نمودار راداری، صرفا به منظور مقایسۀ کارایی
            استانداردها و اپرووالها روغن موتور ها با یکدیگر تهیه شده است.
            بنابراین استفاده از دو استاندارد یا اپرووال با کارایی یکسان و مشابه
            به جای یکدیگر، با استناد به این نمودار مجاز نبوده و حتما مطابق با
            دستورالعمل پیشنهادی تولید کننده وسیله نقلیه خود اقدام به خرید و
            استفاده روغن موتور نمائید.
          </div>
          <div className="modal-body">
            توجه 2: نمودار راداری موجود به منظور مقایسه استانداردها با کلاس
            مشترک تنظیم شده است. به طور مثال مقایسه ACEA E6 با ACEA E7 یا API
            CH-4 با API CJ-4.
          </div>
          <div className="modal-body">
            علی رغم امکان پذیر بودن، مقایسه استانداردها در کلاسهای صنعتی مختلف
            با هم ممکن است نتایج غیر دقیقی به همراه داشته باشد.
          </div>

          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
               راهنمای جدول مقایسه ای
            </h5>
          </div>
          <table>
                    <tbody className="TabelInfo">
                      <tr className="trInfo">
                        <td className="keyTerm">Key</td>
                        <td>Definition</td>
                      </tr>
                      <tr>
                        <td className="keyTerm">
                          HTHS&nbsp;&nbsp;&nbsp;&nbsp;
                        </td>
                        <td>Viscosity at high temperature and shear(cP)</td>
                      </tr>
                      <tr>
                        <td className="keyTerm">SA</td>
                        <td>Sulphated Ash (%)</td>
                      </tr>
                      <tr>
                        <td className="keyTerm">P</td>
                        <td>Phospherus (%)</td>
                      </tr>
                      <tr>
                        <td className="keyTerm">S</td>
                        <td>Sulphur (%)</td>
                      </tr>
                    </tbody>
                  </table>



          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              بستن پنجره
            </button>
          </div>
        </div>
      </div>

     

      
    </div>
  );
}

export default ModalInfo;
